import api from '../api'

function renderSearchList(data) {
  let searchList = ''
  data.forEach(item => {
    searchList += `
    <a target="_blank" href="${api.host}/qa/${item['id']}" title="${
      item.title
    }">
      <li class="hotsearch-item">
        <div class="hotsearch-content">
          <div class="hotsearch-desc">${item.title}</div>
          <div class="hotsearch-info">
            <span class="hotsearch-info-answer">回答${item.commentnum}</span>
            <span class="hotsearch-info-visit">访问${item.seenum}</span>
          </div>
        </div>
        <div class="hotsearch-jump">
          <i class="yxlicon icon-iconfonti"></i>
        </div>
      </li>
    </a>
    `
  })
  return searchList
}

function renderSupportList(data) {
  let searchList = ''
  data.forEach(item => {
    searchList += `
    <a target="_blank" href="${api.host}/qa/${item['question_id']}" title="${
      item.title
    }">
      <li class="hotsearch-item">
        <div class="hotsearch-content">
          <div class="hotsearch-desc">${item.title}</div>
          <div class="hotsearch-info">
            <img src="${
              item.avatar
                ? item.avatar
                : 'http://image.xinli001.com/images/avatar.jpg'
            }" alt="小鲸鱼">
            <span class="hotsearch-info-name">${item.nickname}</span>
            <span class="hotsearch-info-num">的回答（有用${
              item.votenum
            }）</span>
          </div>
        </div>
        <div class="hotsearch-jump">
          <i class="yxlicon icon-iconfonti"></i>
        </div>
      </li>
    </a>
    `
  })
  return searchList
}

module.exports = {
  renderSearchList,
  renderSupportList
}



// WEBPACK FOOTER //
// ./src/pages/ask/askIndex/render/searchList.js